import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcArrowforwardFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "20",
    fill: "none",
    viewBox: "0 0 11 20",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.884 2.116a1.25 1.25 0 1 0-1.768 1.768L7.233 10l-6.117 6.116a1.25 1.25 0 1 0 1.768 1.768l7-7a1.25 1.25 0 0 0 0-1.768z"
  }));
}
var IcArrowforwardFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowforwardFillNomargin));

export { IcArrowforwardFillNomargin as I };
